/*
 * Because IML needs to support IE11 there will be times we need to patch a browser related defect
 * with a vanilla fix. These fixes should be placed here
 *
 */
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
const isEdge = /Edge/.test(navigator.userAgent);

if (isIE11 || isEdge) {
  window.onkeydown = function(e) {
    let preventKeyPress = false;
    if (e.keyCode === 8) {
      let d = e.srcElement || e.target;

      switch (d.tagName.toUpperCase()) {
        case 'TEXTAREA':
          preventKeyPress = d.readOnly || d.disabled;
          break;
        case 'INPUT':
          preventKeyPress =
            d.readOnly ||
            d.disabled ||
            (d.attributes['type'] && ['radio', 'checkbox', 'submit', 'button'].indexOf(d.attributes['type'].value.toLowerCase()) >= 0);
          break;
        case 'DIV':
          preventKeyPress =
            d.readOnly || d.disabled || !(d.attributes['contentEditable'] && d.attributes['contentEditable'].value === 'true');
          break;
        default:
          preventKeyPress = true;
          break;
      }
    }

    if (preventKeyPress) {
      e.preventDefault();
    }
  };
}
